var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.5 13.191A4.185 4.185 0 0 1 16.68 9h14.582c2.309 0 4.238 1.845 4.238 4.191v2.121c0 .837-.677 1.516-1.512 1.516a1.514 1.514 0 0 1-1.511-1.516v-2.12c0-.61-.513-1.16-1.215-1.16H16.679c-.638 0-1.156.519-1.156 1.16v21.617c0 .64.518 1.16 1.156 1.16h14.583c.702 0 1.215-.551 1.215-1.16v-2.121c0-.837.677-1.516 1.511-1.516.835 0 1.512.679 1.512 1.516v2.12c0 2.347-1.93 4.192-4.238 4.192H16.679a4.185 4.185 0 0 1-4.179-4.191V13.19Zm15.841 5.293c.583-.6 1.54-.613 2.138-.029l4.564 4.46a1.518 1.518 0 0 1 0 2.17l-4.564 4.46a1.509 1.509 0 0 1-2.138-.029c-.582-.6-.57-1.56.028-2.143l1.901-1.857h-7.663A1.514 1.514 0 0 1 21.095 24c0-.837.677-1.516 1.512-1.516h7.663l-1.9-1.857a1.519 1.519 0 0 1-.029-2.143Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutB);
export default __webpack_public_path__ + "static/media/logout_b.9a00be829cf6d6bcea0b2384955c3422.svg";
export { ForwardRef as ReactComponent };